import React from 'react';

import RatioQuestionEditor, { Props as EditorProps } from './RatioQuestionEditor';
import RatioQuestionInput, { Props as InputProps } from './RatioQuestionInput';

type EditProps = EditorProps & {
  mode: 'edit';
};

type ViewProps = Pick<InputProps, 'question'> & {
  mode: 'view';
}

type SubmitProps = InputProps & {
  mode: 'submit';
  sectionId: number;
  enrollmentId: number;
  caseId?: number;
}

type Props = EditProps | ViewProps | SubmitProps;

const RatioQuestion: React.FC<Props> = (props: Props) => {
  const { mode } = props;
  if (mode === 'edit') {
    const {
      surveyId,
      sectionId,
      question,
      addQuestion,
      updateQuestion,
      onCancelEdit,
      disableHideAggregation,
    } = props as EditProps;
    return (
      <RatioQuestionEditor
        surveyId={surveyId}
        sectionId={sectionId}
        question={question}
        addQuestion={addQuestion}
        updateQuestion={updateQuestion}
        onCancelEdit={onCancelEdit}
        disableHideAggregation={disableHideAggregation}
      />
    );
  }

  if (mode === 'view') {
    const {
      question,
    } = props as ViewProps;
    return (
      <RatioQuestionInput
        question={question}
      />
    );
  }

  if (mode === 'submit') {
    const {
      caseId,
      enrollmentId,
      sectionId,
      question,
      defaultSubmission,
      disabled,
      required,
      onSave,
      getSaveStatus,
      manualSave,
      saveOnBlur,
    } = props as SubmitProps;
    return (
      <RatioQuestionInput
        question={question}
        defaultSubmission={defaultSubmission}
        disabled={disabled}
        onSave={onSave}
        required={required}
        caseId={caseId}
        enrollmentId={enrollmentId}
        sectionId={sectionId}
        getSaveStatus={getSaveStatus}
        manualSave={manualSave}
        saveOnBlur={saveOnBlur}
      />
    );
  }

  return null;
};

export default RatioQuestion;
